import { useState, useEffect } from 'react';
import { useAuth, useToast } from '../hooks';
import { profileService } from '../services';
import { Button, Input, LoadingSpinner } from '../components';

const Profile = () => {
  const { user, updateUser } = useAuth();
  const { showSuccess, showError } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    timezone: 'America/New_York'
  });

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await profileService.getProfile();
        setProfile(data);
        setFormData({
          firstName: data.user.firstName || '',
          lastName: data.user.lastName || '',
          phone: data.user.phone || '',
          timezone: data.user.timezone || 'America/New_York'
        });
      } catch (err) {
        showError('Failed to load profile');
      } finally {
        setIsLoading(false);
      }
    };

    loadProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    try {
      const updated = await profileService.updateProfile(formData);
      updateUser(updated);
      showSuccess('Profile updated successfully');
    } catch (err) {
      showError(err.message || 'Failed to update profile');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return (
      <div className="dashboard-loading">
        <LoadingSpinner size="lg" />
        <p>Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <h1>Profile</h1>

      <div className="card" style={{ maxWidth: '600px', marginTop: 'var(--spacing-6)' }}>
        <div className="card-header">
          <h3 className="card-title">Personal Information</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <Input
            label="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
          />

          <Input
            label="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />

          <Input
            label="Email"
            value={profile?.user.email || ''}
            disabled
          />

          <Input
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
          />

          <div className="form-group">
            <label className="form-label">Role</label>
            <input
              className="form-input"
              value={profile?.user.role || ''}
              disabled
            />
          </div>

          <Button
            type="submit"
            loading={isSaving}
            style={{ marginTop: 'var(--spacing-4)' }}
          >
            Save Changes
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Profile;
